import { ReactComponent as JoinIconSVG } from "./join-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconJoin(props) {
  return <SvgIcon {...props} component={JoinIconSVG} viewBox="0 0 160 161" />;
}